/*
 * For use it :
 * cube.event.send('modelInformation:caller', {
 *   productId:PRODUCT_ID,
 *   modelReferenceCode:MODEL_ID,
 *   priceNode:PRICE_DOM_ELEMENT
 * });
 *
 */

import { init as buildPrice } from './price-builder';


export const init = () => {

  cube.event.on('modelInformation:caller', (params) => {

    const priceModelApi = 'rest/model/com/decathlon/cube/commerce/pricing/api/PricingActor/getModelPriceInformation';
    const priceParams = {
      productId: params.productId,
      modelReferenceCode: params.modelId
    };

    cube.ajax.post(priceModelApi, priceParams, true).onSuccess((resp) => {

      // Update price node with response
      if(params.priceNode)
        buildPrice(params.priceNode, resp.responseTO.data);

    }).call();

  });
};



// WEBPACK FOOTER //
// ./src/commons/component/price/price.js